export default {
  IntroVideo: 1,
  SetupDepartment: 2,
  SetupEmployee: 3,
  SetupPermission: 4,
};
